import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import ImageCutoutEditPerviewRender from './children/ImageCutoutEditPerviewRender';
import ImageCutoutEditWorkBarRender from './children/ImageCutoutEditWorkBarRender';
import bg1 from '@/assets/images/image-cutout-bg1.png';
import bg2 from '@/assets/images/image-cutout-bg2.png';
import bg3 from '@/assets/images/image-cutout-bg3.png';
import bg4 from '@/assets/images/image-cutout-bg4.png';
import bg5 from '@/assets/images/image-cutout-bg5.png';
import bg6 from '@/assets/images/image-cutout-bg6.png';
import bg7 from '@/assets/images/image-cutout-bg7.png';
import bg8 from '@/assets/images/image-cutout-bg8.png';
import bg9 from '@/assets/images/image-cutout-bg9.png';
import { fabric } from 'fabric';
import '@/utils/fabric/eraser_restore_brush.mixin';
import '@/assets/imageCutout.less';
import { message } from 'antd';
import moment from 'moment';
import Utils from '@/utils';
import sentGAEvent from '@/ga';

class ImageCutoutEditWorkFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colorList: [
        'selector',
        'transparent',
        '#000000',
        '#626262',
        '#FFFFFF',
        '#FF4D4F',
        '#FF7A45',
        '#FFA940',
        '#FFD666',
        '#B4D33F',
        '#52B827',
        '#2E7614',
        '#1B949C',
        '#69C0FF',
        '#2F54EB',
        '#8372FF',
        '#B37FEB',
        '#FF85C0',
      ],
      shadowsColorList: [
        'selector',
        '#000000',
        '#626262',
        '#FFFFFF',
        '#FDF668',
        '#4C69FF',
        '#FF7A45',
      ],
      bgList: [bg1, bg2, bg3, bg4, bg5, bg6, bg7, bg8, bg9],
      brushType: 'erase',
      shadowColor: '#000000',
      brushSize: 20,
      intensitySize: 40,
      radiusSize: 20,
      backgroundImgaeFitType: 'custom',
      oprationType: 'brush', //默认是刷子，而不是移动
      canvasZoom: 1,
      deleteOperateList: [],
      rebackable: false,
      forwardable: false,
      backgroundType: 'direct',
      isShadowsMove: false,
      isShowShadows: false,
      tempMouseDownLoctionPointer: {},
    };
    this.canvasCtx = null;
    this.canvasCtxBG = null;
    this.bgImageRefList = [];
    this.editorContRef = null;

    this.fabricShadow = new fabric.Shadow({
      color: 'rgba(0,0,0,0.4)',
      blur: 20,
      affectStroke: false,
      offsetX: 30,
      offsetY: 30,
    });
    this.lastFabricShadowLoctionPointer = {
      x: 30,
      y: 30,
    };
  }

  componentDidMount() {
    this.canvasInit();
    // this.handleCanvasMove();
  }

  canvasInit = () => {
    //处理画布大小
    const limitWidth = this.editorContRef.clientWidth - 160;
    const limitHeight = this.editorContRef.clientHeight - 250;
    const width = parseInt(this.props.imageCutoutObj.width);
    const height = parseInt(this.props.imageCutoutObj.height);
    let canvasWidth, canvasHeight;
    if (width / height > limitWidth / limitHeight) {
      canvasWidth = limitWidth;
      canvasHeight = limitWidth / (width / height);
    } else {
      canvasHeight = limitHeight;
      canvasWidth = (width / height) * limitHeight;
    }
    //处理图片缩小控制器样式

    let rotateIcon =
      'data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEyIiBmaWxsPSIjODM3MkZGIi8+CjxwYXRoIGQ9Ik0xOCAxMkMxOCA4LjY4NjI5IDE1LjMxMzcgNiAxMiA2QzguNjg2MjkgNiA2IDguNjg2MjkgNiAxMkM2IDE1LjMxMzcgOC42ODYyOSAxOCAxMiAxOEMxMy41OTc4IDE4IDE1LjA0OTggMTcuMzc1NCAxNi4xMjUgMTYuMzU3MSIgc3Ryb2tlPSIjRTNFM0UzIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMTUuNSAxMUgyMC41TDE4IDE0TDE1LjUgMTFaIiBmaWxsPSIjRTNFM0UzIi8+Cjwvc3ZnPgo=';
    let img = document.createElement('img');
    img.src = rotateIcon;

    function renderIcon(ctx, left, top, styleOverride, fabricObject) {
      var size = this.cornerSize;
      ctx.save();
      ctx.translate(left, top);
      ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
      ctx.drawImage(img, -size / 2, -size / 2, size, size);
      ctx.restore();
    }

    fabric.Object.prototype.controls.mtr = new fabric.Control({
      x: 0,
      y: -0.5,
      offsetY: -30,
      cursorStyle: 'crosshair',
      actionHandler: fabric.controlsUtils.rotationWithSnapping,
      actionName: 'rotate',
      render: renderIcon,
      cornerSize: 28,
      withConnection: true,
    });
    fabric.Object.prototype.cornerStyle = false;
    fabric.Object.prototype.cornerSize = 8;
    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.cornerColor = '#8372ff';
    fabric.Object.prototype.borderColor = '#8372ff';
    fabric.Object.prototype.borderDashArray = [5];
    //创建画布
    this.canvasCtx = new fabric.Canvas('image-cutout-canvas', {
      interactive: true,
      allowTouchScrolling: true,
      enableRetinaScaling: true,
      perPixelTargetFind: true, // 对象基于像素检测
      selectable: false,
      centeredScaling: true,
      freeDrawingCursor: `url('data:image/svg+xml,<svg width="${
        this.state.brushSize
      }" height="${
        this.state.brushSize
      }" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11.5" fill="white" stroke="%23A1A1A2"/></svg>') ${
        this.state.brushSize / 2
      } ${this.state.brushSize / 2}, auto`,
    }); //freeDrawingCursor 按住鼠标画出来的圆圈，默认透明
    //创建跟画布一样的矩形，用来当背景颜色
    this.canvasCtx.backgroundRect = new fabric.Rect({
      top: 0,
      left: 0,
      width: canvasWidth,
      height: canvasHeight,
      fill: 'transparent',
      erasable: false,
      selectable: false,
      type: 'rectBg',
    });
    this.canvasCtx.add(this.canvasCtx.backgroundRect);

    //创建图片对象，渲染图片
    fabric.Image.fromURL(
      // this.props.imageCutoutObj.fileurl,
      this.props.base64,
      (img) => {
        this.canvasCtx.mainImage = img.set({
          left: 0,
          top: 0,
          erasable: true,
          opacity: 1,
          minScaleLimit: 0.01,
          lockScalingFlip: true,
        });
        img.scaleToWidth(this.canvasCtx.width);
        //创建已经抠好的图片对象，用于原图裁剪
        fabric.Image.fromURL(
          this.props.imageCutoutObj.cutoutfileurl,
          (_img) => {
            _img
              .set({
                originX: 'center',
                originY: 'center',
                erasable: true,
              })
              .scale(1);
            this.canvasCtx.mainImage.clipPath = _img;
            this.canvasCtx.add(this.canvasCtx.mainImage);
            this.canvasCtx.renderAll();
          },
          { crossOrigin: 'anonymous' }
        );
      },
      { crossOrigin: 'anonymous' }
    );
    this.canvasCtx.setWidth(canvasWidth);
    this.canvasCtx.setHeight(canvasHeight);
    this.canvasCtx.setZoom(1); //应该是用来设置缩放的
    this.canvasCtx.freeDrawingBrush = new fabric.EraserBrush(this.canvasCtx);
    this.canvasCtx.freeDrawingBrush.brushType = 'erase';
    this.canvasCtx.freeDrawingBrush.width = 16;
    this.canvasCtx.isDrawingMode = true;

    //canvas move function
    this.canvasCtx.on('mouse:down', (e) => {
      this.canvasCtx.selectable = false;
      this.canvasCtx.selection = false;
      this.canvasCtx.requestRenderAll();
      if (this.state.oprationType === 'move') {
        this.setState({ panning: true });
        // this.canvasCtx.selection = false;
      }
      if (this.state.oprationType === 'shadowsMove') {
        this.setState({
          panning: true,
        });
        this.state.tempMouseDownLoctionPointer = e.pointer;
      }
    });
    this.canvasCtx.on('mouse:up', (e) => {
      if (this.state.oprationType === 'move') {
        this.setState({ panning: false });
      }
      if (this.state.oprationType === 'shadowsMove') {
        sentGAEvent({
          category: 'BG_shadows',
          action: 'shadows_option',
          label: '2D move_adjust',
        });
        this.setState({
          panning: false,
        });
        this.lastFabricShadowLoctionPointer.x = this.fabricShadow.offsetX;
        this.lastFabricShadowLoctionPointer.y = this.fabricShadow.offsetY;
      }
    });
    this.canvasCtx.on('mouse:move', (e) => {
      if (
        this.state.oprationType === 'shadowsMove' &&
        this.state.panning &&
        this.state.isShadowsMove
      ) {
        let moveX = e.pointer.x - this.state.tempMouseDownLoctionPointer.x;
        let moveY = e.pointer.y - this.state.tempMouseDownLoctionPointer.y;

        this.fabricShadowFun(
          null,
          null,
          moveX + this.lastFabricShadowLoctionPointer.x,
          moveY + this.lastFabricShadowLoctionPointer.y
        );
        return;
      }
      if (
        this.state.oprationType === 'move' &&
        this.state.panning &&
        !this.state.isShadowsMove &&
        e &&
        e.e
      ) {
        if (!e.target || (e.target && e.target.type === 'rectBg')) {
          let delta = new fabric.Point(e.e.movementX, e.e.movementY);
          this.canvasCtx.relativePan(delta);
        }
      }
    });
    this.canvasCtx.on('erasing:end', (e) => {
      this.setState({
        rebackable: true,
        deleteOperateList: [],
      });
    });
  };

  handleBrushType = (brushType) => {
    sentGAEvent({
      category: 'BG_edit',
      action: brushType === 'erase' ? 'BG_eraser_click' : 'BG_restore_click',
      label: `1_${this.state.brushSize}`,
    });
    this.setState({ brushType });
    if (
      this.state.oprationType === 'move' ||
      this.state.oprationType === 'shadowsMove'
    ) {
      this.canvasCtx.discardActiveObject();
      this.setState({
        oprationType: 'brush',
        isShadowsMove: false,
      });
      this.canvasCtx.isDrawingMode = true;
      this.canvasCtx.requestRenderAll();
    }
    this.canvasCtx.freeDrawingBrush.brushType = brushType;
    this.canvasCtx.freeDrawingCursor =
      brushType === 'erase'
        ? `url('data:image/svg+xml,<svg width="${
            this.state.brushSize
          }" height="${
            this.state.brushSize
          }" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11.5" fill="white" stroke="%23A1A1A2"/></svg>') ${
            this.state.brushSize / 2
          } ${this.state.brushSize / 2}, auto`
        : `url('data:image/svg+xml,<svg width="${
            this.state.brushSize
          }" height="${
            this.state.brushSize
          }" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11.5" fill="%238372FF" stroke="%23A1A1A2"/></svg>') ${
            this.state.brushSize / 2
          } ${this.state.brushSize / 2}, auto`;
  };
  handleIntensitySize = (size) => {
    sentGAEvent({
      category: 'BG_shadows',
      action: 'shadows_option',
      label: 'Opacity_adjust',
    });
    this.setState({
      intensitySize: size,
    });
    this.fabricShadowFun(
      null,
      this.state.shadowColor,
      null,
      null,
      this.state.intensitySize / 100
    );
  };
  handleRadiusSize = (size) => {
    sentGAEvent({
      category: 'BG_shadows',
      action: 'shadows_option',
      label: 'Radius_adjust',
    });
    this.setState({
      radiusSize: size,
    });
    this.fabricShadowFun(size, null);
  };
  handleBrushSize = (size) => {
    this.setState({ brushSize: size });
    this.canvasCtx.freeDrawingBrush.width = size;
    this.canvasCtx.freeDrawingCursor =
      this.state.brushType === 'erase'
        ? `url('data:image/svg+xml,<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11.5" fill="white" stroke="%23A1A1A2"/></svg>') ${
            size / 2
          } ${size / 2}, auto`
        : `url('data:image/svg+xml,<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="11.5" fill="%238372FF" stroke="%23A1A1A2"/></svg>') ${
            size / 2
          } ${size / 2}, auto`;
  };
  handleSetBackgroundByColorInput = ({ hex }) => {
    if (hex === '#000') {
      return false;
    }
    this.setState({ backgroundType: 'preset' });
    sentGAEvent({
      category: 'BG_background',
      action: 'BG_background_color_click',
    });
    this.canvasCtx.setBackgroundImage(null);
    this.canvasCtx.backgroundRect.set('fill', hex);
    this.canvasCtx.renderAll();
  };
  handleBackground = (color) => {
    sentGAEvent({
      category: 'BG_background',
      action: 'BG_background_color_click',
    });
    this.setState({
      backgroundType: color === 'transparent' ? 'direct' : 'preset',
    });
    this.canvasCtx.setBackgroundImage(null);
    this.canvasCtx.backgroundRect.set('fill', color);
    this.canvasCtx.renderAll();
  };
  shadowsChange = (e) => {
    if (e) {
      this.canvasCtx.mainImage.shadow = this.fabricShadow;
      sentGAEvent({
        category: 'BG_shadows',
        action: 'shadows_switch',
        label: 'open',
      });
      this.setState({
        isShowShadows: true,
      });
    } else {
      this.canvasCtx.mainImage.shadow = null;
      sentGAEvent({
        category: 'BG_shadows',
        action: 'shadows_switch',
        label: 'close',
      });
      this.setState({
        isShowShadows: false,
      });
    }

    this.canvasCtx.requestRenderAll();
  };
  handleSetShadowColorByColorInput = ({ hex }) => {
    this.setState({
      shadowColor: hex.substring(0, 7),
    });
    this.fabricShadowFun(
      null,
      hex.substring(0, 7),
      null,
      null,
      this.state.intensitySize / 100
    );
  };
  handleShadowColor = (color) => {
    sentGAEvent({
      category: 'BG_shadows',
      action: 'shadows_option',
      label: 'Color_adjust',
    });
    this.setState({
      shadowColor: color,
    });
    this.fabricShadowFun(
      null,
      color,
      null,
      null,
      this.state.intensitySize / 100
    );
  };
  selectShadowsMove = (e) => {
    sentGAEvent({
      category: 'BG_shadows',
      action: 'shadows_option',
      label: '2D move',
    });
    if (!this.canvasCtx.mainImage.shadow) {
      return;
    }
    this.state.isShadowsMove = !this.state.isShadowsMove;
    this.setState({
      isShadowsMove: this.state.isShadowsMove,
      oprationType: 'shadowsMove',
      brushType: '',
    });
    this.canvasCtx.mainImage.evented = false;
    this.canvasCtx.isDrawingMode = false;
    this.canvasCtx.requestRenderAll();
  };
  hexToRgba(hex, opacity) {
    var RGBA =
      'rgba(' +
      parseInt('0x' + hex.slice(1, 3)) +
      ',' +
      parseInt('0x' + hex.slice(3, 5)) +
      ',' +
      parseInt('0x' + hex.slice(5, 7)) +
      ',' +
      opacity +
      ')';
    return {
      red: parseInt('0x' + hex.slice(1, 3)),
      green: parseInt('0x' + hex.slice(3, 5)),
      blue: parseInt('0x' + hex.slice(5, 7)),
      rgba: RGBA,
    };
  }
  fabricShadowFun(blur, color, x, y, opacity) {
    if (blur) {
      this.fabricShadow.blur = blur;
    }
    if (color) {
      this.fabricShadow.color = this.hexToRgba(color, opacity).rgba;
    }
    if (x) {
      this.fabricShadow.offsetX = x;
    }
    if (y) {
      this.fabricShadow.offsetY = y;
    }
    this.canvasCtx.mainImage.shadow = this.fabricShadow;
    this.canvasCtx.requestRenderAll();
  }
  handleBackgroundImage = (index) => {
    sentGAEvent({
      category: 'BG_background',
      action: 'BG_background_photo_click',
    });
    this.setState({ backgroundType: 'preset' });
    this.canvasCtx.customBackgroundImage = null;
    this.canvasCtx.backgroundRect.set('fill', 'transparent');
    let imgInstance = new fabric.Image(this.bgImageRefList[index], {
      erasable: false,
    }).scale(1);
    let coordObj = this.getBackgroundImageCoordAndSize(imgInstance, 'preset');
    imgInstance.scaleToWidth(coordObj.width);
    imgInstance.scaleToHeight(coordObj.height);
    imgInstance.set({
      left: coordObj.left,
      top: coordObj.top,
    });
    this.canvasCtx.setBackgroundImage(imgInstance);
    this.canvasCtx.renderAll();
  };

  handleDownload = () => {
    sentGAEvent({
      category: 'BG_download',
      action: 'BG_download_click',
      label: 'edit_page',
    });
    sentGAEvent({
      category: 'BG_download',
      action: 'BG_download_output',
      label: this.state.backgroundType,
    });
    sentGAEvent({
      category: 'DownloadStart',
      action: '07BC_DownloadStart',
      label: 'Null',
    });
    message.loading(this.props.t('upload:downloading'), 0);
    const ext = 'png';
    this.canvasCtx.setZoom(1);
    let viewportTransform = this.canvasCtx.viewportTransform;
    let delta = new fabric.Point(-viewportTransform[4], -viewportTransform[5]);
    this.canvasCtx.relativePan(delta);
    const base64 = this.canvasCtx.toDataURL({
      format: ext,
      enableRetinaScaling: true,
    });
    const link = document.createElement('a');
    link.href = base64;
    link.target = '_blank';
    link.download = `${moment(new Date()).format('YYYYMMDDHHmmss')}.${ext}`;
    link.click();
    message.destroy();
    this.canvasCtx.setZoom(this.state.canvasZoom);
    let rDelta = new fabric.Point(viewportTransform[4], viewportTransform[5]);
    this.canvasCtx.relativePan(rDelta);
  };

  handleBackgroundImageFit = (value) => {
    sentGAEvent({
      category: 'BG_background',
      action: 'BG_background_fit',
      label: value,
    });
    this.setState({
      backgroundImgaeFitType: value,
    });
    if (!this.canvasCtx.customBackgroundImage) {
      return false;
    }
    let coordObj = this.getBackgroundImageCoordAndSize(
      this.canvasCtx.customBackgroundImage,
      value
    );
    this.canvasCtx.customBackgroundImage.scaleToWidth(coordObj.width);
    this.canvasCtx.customBackgroundImage.scaleToHeight(coordObj.height);
    this.canvasCtx.customBackgroundImage.set({
      left: coordObj.left,
      top: coordObj.top,
    });
    this.canvasCtx.setBackgroundImage(this.canvasCtx.customBackgroundImage);
    this.canvasCtx.renderAll();
  };

  getBackgroundImageCoordAndSize = (img, type) => {
    const limitWidth = this.editorContRef.clientWidth - 160;
    const limitHeight = this.editorContRef.clientHeight - 250;
    let height, width, left, top;
    if (type !== 'custom') {
      //========================画布还原成目标图片大小==============================
      const imgWidth = parseInt(this.props.imageCutoutObj.width);
      const imgHeight = parseInt(this.props.imageCutoutObj.height);
      let canvasWidth, canvasHeight;
      if (imgWidth / imgHeight > limitWidth / limitHeight) {
        canvasWidth = limitWidth;
        canvasHeight = limitWidth / (imgWidth / imgHeight);
      } else {
        canvasHeight = limitHeight;
        canvasWidth = (imgWidth / imgHeight) * limitHeight;
      }
      this.canvasCtx.setWidth(canvasWidth);
      this.canvasCtx.setHeight(canvasHeight);
      this.canvasCtx.mainImage.scaleToWidth(canvasWidth);
      this.canvasCtx.mainImage.scaleToHeight(canvasHeight);
      this.canvasCtx.mainImage.set({
        top: 0,
        left: 0,
      });
      //==========================================================================
      if (type === 'width') {
        width = canvasWidth;
        height = canvasWidth / (img.width / img.height);
        left = 0;
        top = (height - canvasHeight) / 2;
      } else if (type === 'height') {
        height = canvasHeight;
        width = (img.width / img.height) * canvasHeight;
        left = (width - canvasWidth) / 2;
        top = 0;
      } else {
        if (img.width / img.height > canvasWidth / canvasHeight) {
          height = canvasHeight;
          width = (img.width / img.height) * canvasHeight;
          left = (width - canvasWidth) / 2;
          top = 0;
        } else {
          width = canvasWidth;
          height = canvasWidth / (img.width / img.height);
          left = 0;
          top = (height - canvasHeight) / 2;
        }
      }
    } else {
      //========================custom模式下：画布改成背景图大小==============================
      const imgWidth = parseInt(img.width);
      const imgHeight = parseInt(img.height);
      let canvasWidth, canvasHeight;
      if (imgWidth / imgHeight > limitWidth / limitHeight) {
        canvasWidth = limitWidth;
        canvasHeight = limitWidth / (imgWidth / imgHeight);
      } else {
        canvasHeight = limitHeight;
        canvasWidth = (imgWidth / imgHeight) * limitHeight;
      }
      this.canvasCtx.setWidth(canvasWidth);
      this.canvasCtx.setHeight(canvasHeight);
      const mainImageWidth = this.canvasCtx.mainImage.width;
      const mainImageHeight = this.canvasCtx.mainImage.height;
      if (mainImageWidth / mainImageHeight > canvasWidth / canvasHeight) {
        this.canvasCtx.mainImage.scaleToWidth(canvasWidth);
        this.canvasCtx.mainImage.scaleToHeight(
          canvasWidth / (mainImageWidth / mainImageHeight)
        );
        this.canvasCtx.mainImage.set({
          top:
            canvasHeight / 2 -
            canvasWidth / (mainImageWidth / mainImageHeight) / 2,
          left: 0,
        });
      } else {
        this.canvasCtx.mainImage.scaleToWidth(
          (mainImageWidth / mainImageHeight) * canvasHeight
        );
        this.canvasCtx.mainImage.scaleToHeight(canvasHeight);
        this.canvasCtx.mainImage.set({
          top: 0,
          left:
            canvasWidth / 2 -
            ((mainImageWidth / mainImageHeight) * canvasHeight) / 2,
        });
      }
      //=====================================================================================
      height = canvasHeight;
      width = canvasWidth;
      left = 0;
      top = 0;
    }
    return {
      height,
      width,
      left: -left,
      top: -top,
    };
  };

  uploadProps = {
    accept: this.props.imageAccept,
    maxCount: 1,
    showUploadList: false,
    beforeUpload: async (file) => {
      let imageUrl = '';
      try {
        let blobObj = await Utils.fileToBlob(file);
        imageUrl = blobObj.blobUrl;
      } catch {
        return false;
      }
      this.canvasCtx.backgroundRect.set('fill', 'transparent');
      new fabric.Image.fromURL(imageUrl, (img) => {
        sentGAEvent({
          category: 'BG_background',
          action: 'BG_background_upload',
          label: `${file.name.split('.')[file.name.split('.').length - 1]}_${(
            file.size / 1024
          ).toFixed(2)}kb_${img.width}*${img.height}`,
        });
        this.setState({ backgroundType: 'custom' });
        let oImg = img.set({ erasable: false });
        let coordObj = this.getBackgroundImageCoordAndSize(
          img,
          this.state.backgroundImgaeFitType
        );
        img.scaleToWidth(coordObj.width);
        img.scaleToHeight(coordObj.height);
        img.set({
          left: coordObj.left,
          top: coordObj.top,
        });
        this.canvasCtx.setBackgroundImage(oImg);
        this.canvasCtx.customBackgroundImage = img;
        let viewportTransform = this.canvasCtx.viewportTransform;
        let delta = new fabric.Point(
          -viewportTransform[4],
          -viewportTransform[5]
        );
        this.canvasCtx.relativePan(delta);
        this.canvasCtx.renderAll();
      });
    },
  };

  handleCanvasMove = () => {
    sentGAEvent({
      category: 'BG_actionbar',
      action: 'BG_action_move_click',
    });
    // this.canvasCtx.selectable = false;
    this.canvasCtx.discardActiveObject();
    //取消移动
    if (this.state.oprationType === 'move') {
      this.setState({
        oprationType: 'brush',
        brushType: 'erase',
      });
      this.canvasCtx.isDrawingMode = true;
    } else {
      //开启移动
      this.setState({
        oprationType: 'move',
        brushType: '',
        isShadowsMove: false,
      });
      this.canvasCtx.isDrawingMode = false;
      this.canvasCtx.mainImage.evented = true;
    }
    this.canvasCtx.requestRenderAll();
  };

  handleZoomCanvas = (zoom) => {
    if (this.canvasCtx.getZoom() <= 1 && zoom <= 0) {
      return false;
    }
    zoom = zoom + this.canvasCtx.getZoom();
    zoom = Math.max(1, zoom); //最小为原来的1/10
    zoom = Math.min(4, zoom); //最大是原来的3倍
    // let zoomPoint = new fabric.Point(event.pageX, event.pageY);
    // this.canvasCtx.zoomToPoint(zoomPoint, zoom);
    this.canvasCtx.zoomToPoint(
      new fabric.Point(this.canvasCtx.width / 2, this.canvasCtx.height / 2),
      zoom
    );
    this.setState({ canvasZoom: zoom });
  };

  handleZoomCanvasPercent = (zoom) => {
    this.canvasCtx.zoomToPoint(
      new fabric.Point(this.canvasCtx.width / 2, this.canvasCtx.height / 2),
      zoom
    );
    this.setState({ canvasZoom: zoom });
  };

  handlePrevBrush = () => {
    sentGAEvent({
      category: 'BG_actionbar',
      action: 'BG_action_undo_click',
    });
    if (!this.canvasCtx.getObjects('image')[0].clipPath.getObjects) {
      return false;
    }
    const pathList = this.canvasCtx
      .getObjects('image')[0]
      .clipPath.getObjects();
    if (pathList.filter((item) => item.type === 'path').length <= 1) {
      this.setState({ rebackable: false });
    } else {
      this.setState({ rebackable: true });
    }
    if (!pathList.filter((item) => item.type === 'path').length) {
      return false;
    }
    const path = pathList[pathList.length - 1];
    const clipObject = this.canvasCtx
      .getObjects('image')[0]
      .clipPath.removeWithUpdate(path);
    this.canvasCtx.getObjects('image')[0].set({
      clipPath: clipObject,
      dirty: true,
    });
    this.canvasCtx.requestRenderAll();
    const deleteOperateList = [...this.state.deleteOperateList];
    deleteOperateList.push(path);
    this.setState({
      deleteOperateList,
    });
  };

  handleNextBrush = () => {
    sentGAEvent({
      category: 'BG_actionbar',
      action: 'BG_action_redo_click',
    });
    if (!this.state.deleteOperateList.length) {
      return false;
    }
    const path =
      this.state.deleteOperateList[this.state.deleteOperateList.length - 1];
    const clipObject = this.canvasCtx
      .getObjects('image')[0]
      .clipPath.addWithUpdate(path);
    this.canvasCtx.getObjects('image')[0].set({
      clipPath: clipObject,
      dirty: true,
    });
    this.canvasCtx.requestRenderAll();
    const deleteOperateList = [...this.state.deleteOperateList];
    deleteOperateList.pop();
    this.setState({
      deleteOperateList,
      rebackable: true,
    });
  };
  handleShadowChange = (key) => {
    console.log(key);
    switch (key) {
      case '1':
        sentGAEvent({
          category: 'BG_shadows',
          action: 'shadows_option',
          label: 'Opacity',
        });
        break;
      case '2':
        sentGAEvent({
          category: 'BG_shadows',
          action: 'shadows_option',
          label: 'Radius',
        });
        break;
      case '3':
        sentGAEvent({
          category: 'BG_shadows',
          action: 'shadows_option',
          label: 'Color',
        });
        break;
    }
  };

  componentWillUnmount() {
    this.canvasCtx.dispose();
  }

  render() {
    return (
      <div
        className='work-cont-edit'
        ref={(ref) => (this.editorContRef = ref)}
        style={
          document.documentElement.clientWidth >= 992
            ? { height: `${document.documentElement.clientHeight - 97}px` }
            : { height: 'auto' }
        }
      >
        <ImageCutoutEditPerviewRender
          oprationType={this.state.oprationType}
          brushType={this.state.brushType}
          canvasZoom={this.state.canvasZoom}
          deleteOperateList={this.state.deleteOperateList}
          rebackable={this.state.rebackable}
          handlePrevBrush={this.handlePrevBrush}
          handleNextBrush={this.handleNextBrush}
          handleZoomCanvasPercent={this.handleZoomCanvasPercent}
          handleZoomCanvas={this.handleZoomCanvas}
          handleCanvasMove={this.handleCanvasMove}
          handelRebackToUploadSuccessPage={
            this.props.handelRebackToUploadSuccessPage
          }
        />
        <ImageCutoutEditWorkBarRender
          bgImageRefList={this.bgImageRefList}
          uploadProps={this.uploadProps}
          brushSize={this.state.brushSize}
          intensitySize={this.state.intensitySize}
          radiusSize={this.state.radiusSize}
          brushType={this.state.brushType}
          colorList={this.state.colorList}
          shadowsColorList={this.state.shadowsColorList}
          bgList={this.state.bgList}
          backgroundImgaeFitType={this.state.backgroundImgaeFitType}
          shadowColor={this.state.shadowColor}
          isShadowsMove={this.state.isShadowsMove}
          isShowShadows={this.state.isShowShadows}
          handleBrushType={this.handleBrushType}
          handleBrushSize={this.handleBrushSize}
          handleBackground={this.handleBackground}
          handleBackgroundImage={this.handleBackgroundImage}
          handleBackgroundImageFit={this.handleBackgroundImageFit}
          handleSetBackgroundByColorInput={this.handleSetBackgroundByColorInput}
          handleDownload={this.handleDownload}
          shadowsChange={this.shadowsChange}
          handleIntensitySize={this.handleIntensitySize}
          handleRadiusSize={this.handleRadiusSize}
          handleSetShadowColorByColorInput={
            this.handleSetShadowColorByColorInput
          }
          handleShadowColor={this.handleShadowColor}
          selectShadowsMove={this.selectShadowsMove}
          handleShadowChange={this.handleShadowChange}
        />
      </div>
    );
  }
}

export default withTranslation(['imageCutout', 'common', 'uploading'])(
  ImageCutoutEditWorkFunction
);
